import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Btn from '../../UI/Btn'
import styles from './style.module.scss'
import { logIn, setTeacherCompanyView } from '../../redux/ducks/user'
import http, { getAuthInfo } from '../../shared/http'
import { TApi, TRoles, TRoutes } from '../../shared/const'

/*
 * Streifen über jeder Seite, solange jemand die Plattform mit fremden Augen
 * sieht: die Lehrkraft als eine ihrer Schüler:innen, die Verwaltung als
 * Schüler:in oder (seit 02.11.2026) als Lehrkraft.
 *
 * „Ansicht verlassen" setzt den eigenen Token wieder ein und führt dorthin
 * zurück, wo die Ansicht geöffnet wurde. Bis dahin ging es immer auf die
 * Schüler:innenliste der Lehrkraft — die Verwaltung landete damit über einen
 * Umweg auf dem Dashboard statt in ihrer Benutzer:innenliste.
 */
const ADMIN_ROLES = [TRoles.ADMIN, TRoles.FEDERAL_ADMIN]

function AlertTeacherMode(props) {
	const { t } = useTranslation()
	const history = useHistory()
	const handleExitMode = async () => {
		const { token } = getAuthInfo()
		http.defaults.headers['Authorization'] = `Bearer ${token}`
		const { data } = await http.get(TApi.COMMON_ME, { disableToast: true })

		props.setTeacherCompanyView(false)
		props.logIn({
			role: data.role,
			profile: data
		})
		history.push(ADMIN_ROLES.includes(data.role) ? TRoutes.USERS : TRoutes.STUDENTS)
	}

	const name = [props.firstName, props.lastName].filter(Boolean).join(' ')
	const text =
		props.role === TRoles.TEACHER
			? t('viewModeBannerTeacher', { name })
			: t("You are currently in a student's view")

	return (
		<div className={styles.root}>
			<p className={styles.description}>{text}</p>
			<Btn className={styles.exitBtn} onClick={handleExitMode}>
				{t('Exit view mode')}
			</Btn>
		</div>
	)
}

AlertTeacherMode.propTypes = {
	role: PropTypes.string,
	firstName: PropTypes.string,
	lastName: PropTypes.string,
	setTeacherCompanyView: PropTypes.func.isRequired,
	logIn: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
	role: state.user.role,
	firstName: state.user.profile?.firstName,
	lastName: state.user.profile?.lastName
})

const mapDispatchToProps = dispatch => ({
	setTeacherCompanyView: data => dispatch(setTeacherCompanyView(data)),
	logIn: data => dispatch(logIn(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(AlertTeacherMode)
